import _ from 'lodash'
import { Map, Record } from 'immutable'
import { SUCCESS } from 'crom-api-constants'

import { LOGIN_REQUEST, USER_INFO_REQUEST, AVAILABLE_MODULES_REQUEST, SET_LOADING, SET_AUTHORIZE } from './constants'
import { SET_REPORT_MODULE_ACCESS_RIGHTS } from '../../scenes/Gnosus/scenes/Report/constants'
import { SET_PORTFOLIO_MODULE_ACCESS_RIGHTS } from '../../scenes/Gnosus/scenes/Portfolio/constants'
import { RELOAD_UPDATE_USER_DATA_REQUEST } from '../../components/Dialog/components/UserProfile/components/Content/components/EditProfile/components/EditProfileForm/constants'

import { transformReportAccessRightsData, transformPortfolioAccessRightsData } from './helpers'

import config from '../../config'

export const UserRecord = Record({
    userId: null,
    firstName: '',
    lastName: '',
    email: '',
    productId: '',
})

export const ModuleAccessRightRecord = Record({
    key: '',
    available: false,
    hasRights: false,
    order: 0,
    isCustomLoaded: false,
    custom: Map(),
})

export const LicenseRecord = Record({
    licenceId: null,
    licenceName: '',
    licEndDt: null,
    licStrtDt: null,
})

export const CompanyRecord = Record({
    companyCountryIso2: '',
    companyCountryIso3: '',
    companyRegNbr: '',
    companyName: '',
})

// generate AccessRightRecord from modules config
export const AccessRightRecord = Record(
    _.mapValues(
        config.modules,
        (module) =>
            new ModuleAccessRightRecord({
                key: module.key,
                order: module.order,
                available: module.accessRightKey === true,
            })
    )
)

const ImporterRecord = Record({
    available: false,
})

export const AuthorizationRecord = Record({
    isAuthorized: false, // loaded all data for logged user
    isLoading: false,
    sessionId: null,
    uniqueId: null,
    user: new UserRecord(),
    accessRights: new AccessRightRecord(),
    license: new LicenseRecord(),
    company: new CompanyRecord(),
    importer: new ImporterRecord(),
})

export default (state = new AuthorizationRecord(), action = {}) => {
    switch (action.type) {
        case `${LOGIN_REQUEST}_${SUCCESS}`: {
            const sessionId = _.get(action, 'payload.response.body.sessionId', null)

            return state.set('sessionId', sessionId)
        }
        case `${USER_INFO_REQUEST}_${SUCCESS}`: {
            const body = _.first(_.get(action, 'payload.response.body', {}))
            const sessionId = _.get(action, 'payload.originAction.payload.qs.sid', null)

            return state
                .set('user', new UserRecord(_.pick(body, ['userId', 'firstName', 'lastName', 'email', 'productId'])))
                .set('license', new LicenseRecord(_.pick(body, ['licenceId', 'licEndDt', 'licStrtDt', 'licenceName'])))
                .set(
                    'company',
                    new CompanyRecord(
                        _.pick(body, ['companyCountryIso2', 'companyCountryIso3', 'companyRegNbr', 'companyName'])
                    )
                )
                .set('sessionId', sessionId)
        }
        case `${AVAILABLE_MODULES_REQUEST}_${SUCCESS}`: {
            const body = _.first(_.get(action, 'payload.response.body', {}))

            const availableImporter = !!_.get(body, 'groupImporter', false)
            // use modules config for deep merge of accessRights
            return state
                .set(
                    'accessRights',
                    state.get('accessRights').mergeDeep(
                        _.mapValues(config.modules, (module) => {
                            // user has rights from response or rights are hardcoded in config
                            const hasRights =
                                body[module.accessRightKey] === 1 ||
                                state.getIn(['accessRights', module.key, 'available']) === true
                            const isEnabled = !!module.enable

                            // module is available when is enabled in config AND user has rights for module
                            // but module could be unavailable, but user can has rights to module
                            return {
                                available: isEnabled && hasRights,
                                hasRights,
                            }
                        })
                    )
                )
                .setIn(['importer', 'available'], availableImporter)
        }
        case SET_REPORT_MODULE_ACCESS_RIGHTS: {
            const types = _.get(action, 'data.accessRights.types', {})

            const data = transformReportAccessRightsData(types)

            return state
                .setIn(['accessRights', config.modules.report.key, 'custom'], data)
                .setIn(['accessRights', config.modules.report.key, 'isCustomLoaded'], true)
        }
        case SET_PORTFOLIO_MODULE_ACCESS_RIGHTS: {
            const types = _.get(action, 'data.accessRights.types', {})

            const data = transformPortfolioAccessRightsData(types)

            return state
                .setIn(['accessRights', config.modules.portfolio.key, 'custom'], data)
                .setIn(['accessRights', config.modules.portfolio.key, 'isCustomLoaded'], true)
        }
        case SET_LOADING: {
            const isLoading = _.get(action, 'data.isLoading', false)

            return state.set('isLoading', isLoading)
        }
        case SET_AUTHORIZE: {
            const isAuthorized = _.get(action, 'data.isAuthorized', false)

            return state.set('isAuthorized', isAuthorized)
        }

        case `${RELOAD_UPDATE_USER_DATA_REQUEST}_${SUCCESS}`: {
            const body = _.first(_.get(action, 'payload.response.body', {}))
            const firstName = _.get(body, 'firstName', '')
            const lastName = _.get(body, 'lastName', '')
            const email = _.get(body, 'email', '')

            return state
                .setIn(['user', 'firstName'], firstName)
                .setIn(['user', 'lastName'], lastName)
                .setIn(['user', 'email'], email)
        }
        default:
            return state
    }
}
